export default "__VITE_ASSET__BQDCRTaK__"